import styled from '@emotion/styled';
import React, { FC } from 'react';
import Heading from '~ComponentsImproved/Typography/Heading';
import { useButton } from '~Hooks';
import { BlueButton, Box } from '~Styles';
import useI18n from '~Translations';
import { printReport, ReportRow } from './utils';

export const Row = styled.div<{ isHeader?: boolean }>`
  display: flex;
  font-size: ${({ isHeader }) => (isHeader ? '18px' : '16px')};
  font-weight: ${({ isHeader }) => (isHeader ? 600 : 'normal')};

  margin-bottom: 4px;
  padding-bottom: 4px;

  margin-top: ${({ isHeader }) => (isHeader ? '24px' : '0')};

  border-bottom: 1px solid var(--colorBlueGray200);
`;

export const Text = styled.div<{ isNumber?: boolean; bold?: boolean }>`
  width: 180px;
  text-align: right;
  font-weight: ${({ bold }) => (bold ? '600' : 'inherit')};
  white-space: pre;

  &:first-of-type {
    margin: 0 auto 0 0;
    width: auto;
    text-align: left;
  }

  &:nth-of-type():not(:last-of-type) {
    width: 120px;
  }
`;

interface Props {
  title: string;
  subTitle?: string;
  rows: ReportRow[];
}

const ReportView: FC<Props> = ({ title, subTitle = '', rows }) => {
  const { i18n } = useI18n();

  const printButton = useButton({
    onClick: () => {
      printReport(title, rows, i18n, subTitle);
    },
  });

  const isHandyBreakpoint = window.innerWidth <= 600;

  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center" marginBottom="medium">
        <Heading
          level={3}
          color={isHandyBreakpoint ? 'var(--colorWhite)' : 'var(--colorBlueGray1300)'}>
          {title} {isHandyBreakpoint && <br />} {subTitle}
        </Heading>
        <BlueButton {...printButton}>{i18n('Report.PrintReport')}</BlueButton>
      </Box>
      {rows.map((row, index) => (
        <Row key={index} isHeader={row.isHeader}>
          <Text bold={row.bold}>{row.leftText}</Text>
          <Text bold={row.bold} isNumber>
            {row.rightText}
          </Text>
        </Row>
      ))}
    </>
  );
};

export default ReportView;
